import { FormFieldConfig } from "Components/Common/CommonForm";
import { Controller } from "react-hook-form";
import { Badge } from "reactstrap";
import styles from "../css/studyicf.module.scss";
import { validations } from "validations/FormValidations";
import TruncatedText from "Components/Common/TruncatedText";

export const remarksSubmissionFields: FormFieldConfig[] = [
  {
    name: "remarks",
    label: "Remarks",
    type: "textarea",
    placeholder: "Enter submission remarks here...",
    required: true,
    rules: validations.studyicf.remarks,
  }
];

export const studyICFColumns:FormFieldConfig[] = [
                  {
                    name: "investigator_name",
                    label: "Investigator Name",
                    type: "text",
                    placeholder: "Enter investigator's name",
                    required: true,
                  },
                  {
                    name: "remarks",
                    label: "Remarks (Optional)",
                    type: "textarea",
                    placeholder: "Add observational remarks...",
                  }
                ]


export const SwitchField = ({
  name,
  label,
  icon,
  options,
  control,
  required,
  disabled,
}: {
  name: string;
  label: string;
  icon: string;
  options: any[];
  control: any;
  required?: boolean;
  disabled?: boolean;
}) => (
  <div
    className={`mb-2 p-2 px-3 bg-white rounded-3 d-flex align-items-center justify-content-between ${styles.yes_no_wrapper}`}
  >
    <div className="d-flex align-items-center gap-3" style={{ minWidth: 0, flex: 1 }}>
      <div className="avatar-xs flex-shrink-0">
        <span className="avatar-title bg-info-subtle text-info rounded-circle fs-6">
          <i className={icon}></i>
        </span>
      </div>
      <h6 className="mb-0 fs-13 fw-semibold text-dark">
        <TruncatedText text={label} maxWidth="400px" />
        {required && !disabled && <span className="text-danger ms-1 flex-shrink-0">*</span>}
      </h6>
    </div>

    <Controller
      name={name}
      control={control}
      rules={{ required: required && !disabled ? "Required" : false }}
      render={({ field }) => {
        if (disabled) {
          const selectedOpt = options.find(
            (opt) => String(opt.value) === String(field.value),
          );
          const isYes = selectedOpt?.label.toLowerCase() === "yes";
          if (!selectedOpt) {
            return (
              <Badge
                className={`rounded-pill px-3 py-1 fs-11 ${styles.na_badge}`}
                style={{ minWidth: "55px" }}
              >
                N/A
              </Badge>
            );
          }

          return (
            <Badge
              color={isYes ? "primary" : "dark"}
              className="rounded-pill px-3 py-1 fs-11"
              style={{ minWidth: "55px" }}
            >
              {selectedOpt.label}
            </Badge>
          );
        }

        return (
          <div className="btn-group btn-group-sm shadow-sm" role="group">
            {options.map((opt) => {
              const isActive = String(field.value) === String(opt.value);
              const isYes = opt.label.toLowerCase() === "yes";
              return (
                <button
                  key={opt.value}
                  type="button"
                  className={`btn px-3 fw-bold ${
                    isActive
                      ? isYes
                        ? "btn-primary"
                        : "btn-light border active text-primary"
                      : "btn-light border text-muted"
                  }`}
                  onClick={() => field.onChange(String(opt.value))}
                  style={{ fontSize: "11px" }}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>
        );
      }}
    />
  </div>
);                

export const QuestionSkeleton = () => (
  <div className="mb-2 p-3 bg-white rounded-3 d-flex align-items-center justify-content-between placeholder-glow border border-light shadow-sm">
    <div className="d-flex align-items-center gap-3 flex-grow-1">
      <div
        className="avatar-xs flex-shrink-0 bg-light rounded-circle placeholder"
        style={{ width: "32px", height: "32px" }}
      ></div>
      <div
        className="placeholder col-8 rounded"
        style={{ height: "14px" }}
      ></div>
    </div>
    <div
      className="placeholder col-3 rounded ms-4"
      style={{ height: "26px" }}
    ></div>
  </div>
);


export const YES_NO_OPTIONS = [
  { label: "Yes", value: "1" },
  { label: "No", value: "0" },
];